import React, { createContext } from 'react';
import PropTypes from 'prop-types';

function RetrieveErrorProvider({ children }) {

  const [hasError, setHasError] = React.useState(false);

  function addError() {
    setHasError(true);
  }

  return (
    <RetrieveErrorContext.Provider
      value={{
        hasError,
        addError,
      }}
    >
      {children}
    </RetrieveErrorContext.Provider>
  );
}

const RetrieveErrorContext = createContext(null);

export { RetrieveErrorContext, RetrieveErrorProvider };

RetrieveErrorProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};
